export const messages = {
  pdfSuccessMessage: "PDF downloaded successfully",
  validationErrorMessage: "This Field is required",
  toasterErrorMessage:
    "Please provide the details for the above required field",
};
